<div class="stars-container">
    <div class="star" >
        <span class="number-label">1</span>
        <div class="stars">
            <mat-icon *ngFor="let star of starOptions" class="star-icon" [ngClass]="{'green': star.status}" (click)="onClickStar(star)">star</mat-icon>
        </div>
        <span class="number-label">5</span>
    </div>
</div>